import dayjs from 'dayjs'

// период отчёта — это `period_type` + `period_start`. Поле `quarter` осталось якорем квартала,
// содержащего начало периода: у мартовского отчёта там 1 января, поэтому подписывать период по нему
// нельзя. У отчётов, заведённых до появления периодов, заполнен только quarter — он и служит фолбэком
export const DEFAULT_PERIOD_TYPE = 'quarter'

export const getPeriodType = report => report?.period_type || DEFAULT_PERIOD_TYPE

export const getPeriodStart = report => report?.period_start || report?.quarter

const monthsInPeriod = { month: 1, quarter: 3, half: 6, year: 12 }

const getPeriodLength = periodType => monthsInPeriod[periodType] || monthsInPeriod[DEFAULT_PERIOD_TYPE]

export const getPeriodNumber = (date, periodType = DEFAULT_PERIOD_TYPE) =>
	Math.floor(dayjs(date).month() / getPeriodLength(periodType)) + 1

// M3'25 / Q1'25 / H1'25 / Y'25
export const formatPeriod = (date, periodType = DEFAULT_PERIOD_TYPE) => {
	if (!date) return ''

	const d = dayjs(date)
	if (!d.isValid()) return ''

	const year = d.format('YY')
	if (periodType === 'year') return `Y'${year}`

	const prefix = { month: 'M', half: 'H' }[periodType] || 'Q'
	return `${prefix}${getPeriodNumber(d, periodType)}'${year}`
}
